/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import IdentityModel from 'cio/models/identity';

interface FromIdentityTableArgs {
  canVerify: boolean;
  domainName?: string;
  identities: IdentityModel[];
  identitiesInUse?: IdentityModel[];
  readOnly: boolean;
  showVerificationStatus: boolean;
  onUpdateIdentity: () => unknown;
}

export default class FromIdentityTable extends Component<FromIdentityTableArgs> {}
